export default {
  common: {
    requestError: 'There was an error with your request',
    serverError: 'Oops, something went wrong with the server',
    confirm: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    back: 'Back',
    quit: 'Quit',
    add: 'Add',
    copy: 'Copy',
    all: 'All',
    remove: 'Remove',
    project: 'Project',
    folder: 'Folder',
    more: 'More options',
    copySuccess: 'Copied successfully',
    operateSuccess: 'Operation successful',
    addSuccess: 'Added successfully',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
    cantPreview: 'Preview not available',
    newFeature: 'New feature coming soon, stay tuned',
    noQuota: 'Your account has expired. Please contact the administrator!',
  },
  enum: {
    needReview: 'Needs Review',
    inProgress: 'In Progress',
    approved: 'Approved',
    disapproved: 'Rejected',
    noStatus: 'No Status',
    reviewer: 'Reviewer',
    admin: 'Administrator',
    editor: 'Editor',
    collaborator: 'Collaborator',
    owner: 'Owner',
    queue: 'In queue',
    uploading: 'Uploading',
    paused: 'Paused',
    completed: 'Completed',
    failed: 'Failed',
    reading: 'Reading',
  },
  login: {
    welcome: 'Welcome!',
    description: 'Share your creative works here.',
    accountLogin: 'Username/Phone and password to log in.',
    account: 'Username / Phone number',
    password: 'Password',
    start: 'Get started',
    noAccount: "Don't have an account yet? ",
    register: 'Register',
    other: 'Log in with',
    wechat: 'Scan the QR code with WeChat',
    scan: 'Scan successful',
    confirm: 'Please confirm on your phone if you authorize this login',
    back: 'Back to login',
    captcha: 'Captcha',
    needModifyPassword: 'Password complexity is too low, please change your password.',
  },
  register: {
    name: 'Username',
    account: 'Phone number',
    password: 'Password',
    confirm: 'Sign up',
    had: 'Already have an account? ',
    login: 'Log in',
    passwordTip: 'The password must contain 8 to 18 characters and include at least three of the following: numbers, uppercase letters, lowercase letters, and special characters.',
    accountTip: 'Please enter a username between 2 and 18 characters long',
    phoneTip: 'Please enter a valid phone number',
    required: 'Please fill in all required fields correctly',
    success: 'Registration successful, please log in',
  },
  main: {
    home: 'Home',
    search: 'Search',
    add: 'Add Project',
    jump: 'Jump to folder or file',
    progress: 'Upload progress',
    contact: 'Contact us',
    locale: 'Switch Language',
    logout: 'Log out',
    confirmLogout:
      'There are files being uploaded, logging out will cancel the upload. Are you sure you want to log out?',
    project: 'My Projects',
    manage: 'Manage members',
    cancelTop: 'Cancel pin to top',
    top: 'Pin to top',
    setting: 'Project Setting',
    allowDownload: 'Allow downloads',
    allowShare: 'Allow shares',
    allowCollect: 'Allow collects',
    delete: 'Delete Project',
    quit: 'Quit Project',
    empty:
      'The team has no Projects yet. Click the "New Project" button to create a new Project.',
    confirmQuit: 'Are you sure you want to quit Project {0}?',
    confirmDelete:
      'Are you sure you want to delete Project {0}? All files managed by the Project will be deleted permanently and cannot be recovered!!<br /> <br /> Please type DELETE to confirm',
      confirmDeleteTips: 'Please type DELETE to confirm the deletion',
    },
  collect: {
    confirmDelete: 'Are you sure you want to delete "{0}"?',
    copyLinkSuccess: 'Link copied successfully',
    copyPasswordSuccess: 'Password copied successfully',
    copyUsernameSuccess: 'Username copied successfully',
    wechatScan: 'Scan with WeChat',
    copyPasswordTips: 'Click to copy password',
    copyUsernameTips: 'Click to copy username',
    copyLink: 'Copy link',
    shareLink: 'Share link',
    allowComment: 'Allow Comments',
    allowUpload: 'Allow Uploads',
    shareFTP: 'Share FTP',
    allowDownload: 'Allow Downloads',
    forever: 'Forever',
    linkForever: 'Permanently valid',
    expireTo: 'Valid until{0}',
    day: '{0} days',
    accessPassword: 'Passphrase Protect',
    username: 'Username',
    expire: 'Expiration',
    expireTips: 'Choose expiration date',
    description: 'Add description (optional)',
    tips: 'This link is no longer accessible. If you still need access, please contact the account owner',
    back: 'Back to Frame.Lux',
    chooseFiles: 'Choose files',
    chooseFolders: 'Choose folders',
    upload: 'Upload',
    noSpace:
      'Not enough space, please contact the administrator to upgrade/renew',
    password: 'Please enter password',
    passwordTips: 'Please enter the correct password',
  },
  upload: {
    complete: 'Upload complete',
    waiting: 'Waiting',
    abandon: 'Abandon',
    continue: 'Continue',
    confirm: 'Please confirm',
    confirmMsg:
      'There are files in the list that have not been uploaded. Are you sure you want to abandon uploading?',
    empty: 'No files are uploading',
    uploaded: 'Successfully uploaded {0} items',
    canelAll: 'Cancel all',
    uploading: 'Uploading {complete} / {total}',
    pause: 'Pause',
    recover: 'Recover',
    cancel: 'Cancel',
    cancelAll: 'Cancel All',
    open: 'Open containing folder',
  },
  search: {
    filters: 'Filters',
    filterCount: '{0} filters',
    addFilter: 'Add filter',
    tips: 'Search for assets and folders',
    empty: 'No relevant results found',
  },
  file: {
    label: 'Label',
    project: 'Project',
    audit: 'Audit Status',
    accessStatus: 'Access Status',
    link: 'Link',
    expire: 'Expiration',
    createTime: 'Creation Time',
    deleteTime: 'Deletion Time',
    views: 'Views',
    deletor: 'Deletor',
    fileName: 'File Name',
    resolution: 'Resolution',
    framerate: 'Frame Rate',
    codec: 'Video Codec',
    bitrate: 'Bitrate',
    audioCount: 'Audio Tracks',
    audioSampleRate: 'Audio Sample Rate',
    scanType: 'Scan Mode',
    pregressive: 'Progressive',
    interlaced: 'Interlaced',
    duration: 'Duration',
    title: 'Title',
    uploadTime: 'Upload Time',
    uploader: 'Uploader',
    size: 'Size',
    status: 'Status',
    type: 'Type',
    operation: 'Operation',
    queued: 'Queued',
    paused: 'Paused',
    importFailed: 'Import Failed',
  },
  share: {
    download: 'Download',
    tips: 'This link is no longer accessible. Please contact the account owner if you still need access.',
    back: 'Back to Frame.Lux',
    noFile: 'No files available!',
    root: '{0} shared files',
    noDownload: 'No files to download',
    downloading: 'Downloading {0} files',
    password: 'Enter password',
    passwordTips: 'Please enter the correct password',
  },
  player: {
    play: 'Play [K]',
    pause: 'Pause [K]',
    loop: 'Loop',
    unmute: 'Unmute [M]',
    mute: 'Mute [M]',
    timecode: 'Timecode',
    standard: 'Standard',
    frame: 'Frame',
    code: 'Time Code',
    collapseCut: 'Collapse Cut',
    cancelComment: 'Cancel Comment',
    cancelCommentSelect: 'Cancel Comment Select',
    playbackRate: 'Playback Speed',
    standardSpeed: 'Normal',
    linkTimeline: 'Link Timeline',
    fullscreen: 'Fullscreen [F]',
    exitFullscreen: 'Exit Fullscreen [Esc]',
    playlist: 'Playlist [Tab]',
  },
  review: {
    fileDeleted: 'This file has been deleted',
    forbidden: 'No permission to perform this action',
    cantPreview: 'Cannot preview file at this time, please try again later',
    download: 'Download',
    saveAs: 'Save As',
    print: 'Print Comments',
    commentTitle: 'Comments',
    fileTitle: 'File Info',
    addTag: 'Add/Search Tags',
    allTag: 'All Tags',
    addTagTips: 'Please add tags',
    noTagTips: 'No tags available',
    allUser: 'All Users',
    timecode: 'By Timecode',
    time: 'By Comment Time',
    modifySuccess: 'Modified successfully',
    deleteSuccess: 'Deleted successfully',
    sendSuccess: 'Sent successfully',
    deleteComment: 'Delete Comment',
    confirmDelete: 'Confirm to delete comment [{0}]',
    undo: 'Undo',
    redo: 'Redo',
    clear: 'Clear Canvas and Exit',
    commentTips: 'Enter your review comments...',
    addTimecode: 'Add Timestamp',
    at: "{'@'}",
    attach: 'Attachment',
    send: 'Send',
  },
  project: {
    mode916: '9:16',
    modeList: 'List',
    modeThumb: 'Thumbnail',
    moveTo: 'Move to',
    copyTo: 'Copy to',
    defaultFolder: 'New Folder',
    defaultProject: 'New Project',
    defaultNote: 'New Note',
    assignRole: 'Assign Role',
    modifyTips: 'Confirm to modify user [{name}] to role [{role}]',
    removeMember: 'Remove User',
    removeTips: 'Confirm to remove user [{0}]',
    memberCount: '{0} members in this Project',
    invite: 'Invite',
    searchUserTips: 'Enter name to search',
    noMatchTips: 'No matching users found',
    space: 'Space used <span class="emphasize">{size}</span>',
    count:
      'Contains <span class="emphasize">{assetCount}</span> files and <span class="emphasize">{folderCount}</span> folders',
    sortByTitle: 'Sort by Title',
    sortByTime: 'Sort by Time',
    sortByType: 'Sort by Type',
    sortByStatus: 'Sort by Status',
    new: 'New',
    uploadFiles: 'Upload Files',
    uploadFolders: 'Upload Folders',
    newFolder: 'New Folder',
    newNote: 'New Note',
    newProject: 'New Project',
    collect: 'Collect Files',
    ftp: 'Create FTP Links',
    refresh: 'Refresh',
    file: 'Project',
    trashcan: 'Recycle Bin',
    shareLink: 'Review Links',
    collectLink: 'Collection Links',
    ftpLink: 'FTP Links',
    folderTitle: 'Folder',
    fileTitle: 'File',
    empty: 'No files yet!',
    trashcanEmpty:
      'The Recycle Bin is empty. You can use it to restore deleted files.',
    shareEmpty:
      'No shared links yet. You can view them here after creating a shared link.',
    collectEmpty:
      'No collection links yet. You can view them here after creating a collection link.',
    ftpEmpty: 'No FTP links yet. You can view them here after creating a ftp link.',
    shareSetting: 'Share Setting',
    deleteShare: 'Delete',
    ftpSetting: 'FTP Setting',
    deleteFtp: 'Delete',
    passwordCopySuccess: 'Password copied successfully',
    collectSetting: 'Collection Setting',
    deleteCollect: 'Delete',
  },
  notification: {
    notificationSetting: 'Notification Setting',
    allRead: 'Mark all as Read',
    deleteRead: 'Delete Read message',
    emptyNotification: 'No notifications',
    notification: 'Notification',
    emptyMsg: 'No messages',
    msg: 'Message',
    atMsg: "{'@'} message",
    project: 'Project',
    at: '<span class="bold">{who}</span> mentioned you in <span class="bold">{name}</span>',
  },
  menu: {
    clear: 'Clear Recycle Bin',
    restoreTo: 'Restore to original location',
    delete: 'Delete',
    download: 'Download',
    copyTips:
      'Your space is full. Please contact the administrator to expand the space or clear space before copying.',
    copyTo: 'Copy to',
    moveTo: 'Move to',
    rename: 'Rename',
    share: 'Share',
    pictureImagine: 'Picutre Imagine',
    speechToText: 'Speech To Text',
    publish: 'Publish',
    deleteFile: 'Delete File',
    deleteFileCount: 'Delete {0} files',
    confirmDeleteFile:
      'Are you sure you want to delete the file "{0}"? After deletion, the file will be moved to the Recycle Bin.',
    confirmDeleteFileCount:
      'Are you sure you want to delete these {0} files? After deletion, the files will be moved to the Recycle Bin.',
    emptyDownloadTips: 'No files to download',
    downloadCount: 'Downloading {0} files',
    renameSuccess: 'Renamed successfully',
    renameFile: 'Rename file',
    renameFolder: 'Rename folder',
    noSpaceTips:
      'Your space is full. Please contact the administrator to expand the space or clear space before uploading.',
    createShare: 'Create Share',
    createCollect: 'Create Collection',
    createFtp: 'Create FTP Link',
    projectMembers: 'Project Members',
    purgeFile: 'Permanently delete file',
    purgeFileCount: 'Permanently delete {0} files',
    confirmPurgeFile: 'Are you sure you want to permanently delete {0}?',
    confirmPurgeFileCount:
      'Are you sure you want to permanently delete these {0} files?',
    purge: 'Permanently Delete',
    restore: 'Restore',
    restoreFile: 'Restore File',
    restoreFileCount: 'Restore {0} files',
    confirmRestoreFile: 'Are you sure you want to restore {0}?',
    confirmRestoreFileCount:
      'Are you sure you want to restore these {0} files?',
  },
  other: {
    teamTips:
      'There are files being uploaded. Switching teams will cancel the upload. Are you sure you want to proceed?',
    publish: 'Publish Center',
    personal: 'Setting',
    tools: 'AI Tools',
    logout: 'Log Out',
    space: 'Space Usage',
    equal: 'Equals',
    contactTips:
      'Any suggestion or question, please scan the QR code to contact us.',
  },
  editor: {
    loading: 'Loading...',
    askAi: 'AI',
    script1: '生成宣传文案',
    script2: '生成直播话术',
    script3: '内容仿写',
  },
  imagination: {
    imagination: 'Picture Imagination',
    generate: 'Generate',
    generateTips: 'Some keywords',
    save: 'Save',
    suggest: 'Suggestion',
    download: 'Dwonload',
    variation: 'Variation {0}',
    upscale: 'Upscale {0}',
    reroll: 'Reroll'
  },
  password: {
    title: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    passwordIncorrect: 'The old password is incorrect, please try again.',
    passwordDuplicate: 'Don\'t reuse the passwords from the last three times. Please set a new password.',
    modifySuccess: 'Password modified successfully',
    requiredTips: 'Please fill in the required information correctly.',
    needInitPassword: 'For the security of your account, please change your initial password first.',
    needModifyPassword: 'The password has not been changed for a long time. For the security of your account, please change the password first.', // 太长时间没有修改密码，请先修改密码
    passwordTips: 'The password must contain 8 to 18 characters and include at least three of the following: numbers, uppercase letters, lowercase letters, and special characters.',
  },
}
